import React from 'react';
import { useTranslation } from 'react-i18next';
import './Privacy.css';

export const Privacy = () => {
  const { i18n } = useTranslation();
  const isGerman = i18n.language === 'de';

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>{isGerman ? 'Datenschutzerklärung' : 'Privacy Policy'}</h1>
        
        {isGerman ? (
          <>
            <section>
              <h2>1. Datenschutz auf einen Blick</h2>
              <h3>Allgemeine Hinweise</h3>
              <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
            </section>

            <section>
              <h2>2. Datenerfassung auf dieser Website</h2>
              <h3>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h3>
              <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Die Kontaktdaten finden Sie im Impressum dieser Website.</p>
              
              <h3>Wie erfassen wir Ihre Daten?</h3>
              <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
              <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).</p>
            </section>

            <section>
              <h2>3. Welche Daten werden erhoben?</h2>
              <p>Wir erheben folgende personenbezogene Daten:</p>
              <ul>
                <li>E-Mail-Adresse</li>
                <li>Vorname und Nachname</li>
                <li>Versandadresse (Straße, Hausnummer, PLZ, Stadt, Land)</li>
                <li>Name des Sponsors</li>
                <li>MPG-Registrierungsdatum</li>
              </ul>
            </section>

            <section>
              <h2>4. Wofür nutzen wir Ihre Daten?</h2>
              <p>Die Daten werden erhoben, um:</p>
              <ul>
                <li>Ihre Versandadresse zu verwalten</li>
                <li>Ihnen Zugang zu Ihrem Konto zu ermöglichen</li>
                <li>Ihnen automatisch generierte Passwörter zuzusenden</li>
                <li>Sie über Änderungen Ihrer Versandadresse zu informieren</li>
                <li>Passwort-Reset-Links zu versenden</li>
              </ul>
            </section>

            <section>
              <h2>5. Google reCAPTCHA</h2>
              <p>Wir nutzen "Google reCAPTCHA" (im Folgenden "reCAPTCHA") auf dieser Website. Anbieter ist die Google Ireland Limited ("Google"), Gordon House, Barrow Street, Dublin 4, Irland.</p>
              <p>Mit reCAPTCHA soll überprüft werden, ob die Dateneingabe auf dieser Website (z.B. in einem Kontaktformular) durch einen Menschen oder durch ein automatisiertes Programm erfolgt. Hierzu analysiert reCAPTCHA das Verhalten des Websitebesuchers anhand verschiedener Merkmale.</p>
            </section>

            <section>
              <h2>6. E-Mail-Versand</h2>
              <p>Wir versenden E-Mails über IONOS (smtp.ionos.de) für:</p>
              <ul>
                <li>Willkommens-E-Mails mit Ihrem automatisch generierten Passwort</li>
                <li>Passwort-Reset-Links</li>
                <li>Bestätigungen von Adressänderungen</li>
              </ul>
            </section>

            <section>
              <h2>7. Ihre Rechte</h2>
              <p>Sie haben jederzeit das Recht:</p>
              <ul>
                <li>Auskunft über Ihre bei uns gespeicherten Daten zu erhalten</li>
                <li>Berichtigung unrichtiger Daten zu verlangen</li>
                <li>Löschung Ihrer Daten zu verlangen</li>
                <li>Einschränkung der Datenverarbeitung zu verlangen</li>
                <li>Widerspruch gegen die Verarbeitung einzulegen</li>
              </ul>
            </section>

            <section>
              <h2>8. Datensicherheit</h2>
              <p>Wir verwenden moderne Sicherheitsmaßnahmen zum Schutz Ihrer Daten:</p>
              <ul>
                <li>SSL/TLS-Verschlüsselung für alle Datenübertragungen</li>
                <li>Bcrypt-Hashing für Passwörter</li>
                <li>JWT-Token-basierte Authentifizierung</li>
                <li>reCAPTCHA-Schutz gegen automatisierte Angriffe</li>
              </ul>
            </section>

            <section>
              <h2>9. Kontakt</h2>
              <p>Bei Fragen zum Datenschutz wenden Sie sich bitte an:</p>
              <p><strong>E-Mail:</strong> info@alberto.at</p>
            </section>
          </>
        ) : (
          <>
            <section>
              <h2>1. Data Protection at a Glance</h2>
              <h3>General Information</h3>
              <p>The following notes provide a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to personally identify you.</p>
            </section>

            <section>
              <h2>2. Data Collection on This Website</h2>
              <h3>Who is responsible for data collection on this website?</h3>
              <p>Data processing on this website is carried out by the website operator. Contact details can be found in the imprint of this website.</p>
              
              <h3>How do we collect your data?</h3>
              <p>Your data is collected by you providing it to us. This may be data that you enter into a contact form, for example.</p>
              <p>Other data is collected automatically or with your consent when you visit the website by our IT systems. This is primarily technical data (e.g. internet browser, operating system, or time of page access).</p>
            </section>

            <section>
              <h2>3. What Data is Collected?</h2>
              <p>We collect the following personal data:</p>
              <ul>
                <li>Email address</li>
                <li>First and last name</li>
                <li>Shipping address (street, house number, ZIP, city, country)</li>
                <li>Sponsor name</li>
                <li>MPG registration date</li>
              </ul>
            </section>

            <section>
              <h2>4. How Do We Use Your Data?</h2>
              <p>The data is collected to:</p>
              <ul>
                <li>Manage your shipping address</li>
                <li>Provide access to your account</li>
                <li>Send you auto-generated passwords</li>
                <li>Notify you about changes to your shipping address</li>
                <li>Send password reset links</li>
              </ul>
            </section>

            <section>
              <h2>5. Google reCAPTCHA</h2>
              <p>We use "Google reCAPTCHA" (hereinafter "reCAPTCHA") on this website. The provider is Google Ireland Limited ("Google"), Gordon House, Barrow Street, Dublin 4, Ireland.</p>
              <p>reCAPTCHA is used to check whether data entry on this website (e.g. in a contact form) is done by a human or by an automated program. For this purpose, reCAPTCHA analyzes the behavior of the website visitor based on various characteristics.</p>
            </section>

            <section>
              <h2>6. Email Sending</h2>
              <p>We send emails via IONOS (smtp.ionos.de) for:</p>
              <ul>
                <li>Welcome emails with your auto-generated password</li>
                <li>Password reset links</li>
                <li>Address change confirmations</li>
              </ul>
            </section>

            <section>
              <h2>7. Your Rights</h2>
              <p>You have the right at any time to:</p>
              <ul>
                <li>Receive information about your data stored with us</li>
                <li>Request correction of incorrect data</li>
                <li>Request deletion of your data</li>
                <li>Request restriction of data processing</li>
                <li>Object to processing</li>
              </ul>
            </section>

            <section>
              <h2>8. Data Security</h2>
              <p>We use modern security measures to protect your data:</p>
              <ul>
                <li>SSL/TLS encryption for all data transmissions</li>
                <li>Bcrypt hashing for passwords</li>
                <li>JWT token-based authentication</li>
                <li>reCAPTCHA protection against automated attacks</li>
              </ul>
            </section>

            <section>
              <h2>9. Contact</h2>
              <p>For questions about data protection, please contact:</p>
              <p><strong>Email:</strong> info@alberto.at</p>
            </section>
          </>
        )}
      </div>
    </div>
  );
};
